import React, { useEffect } from "react";
import Faqs from "../components/faqs/Faqs";

const PreguntasFrecuentes = () => {
  useEffect(() => {
    document.title = "Preguntas Frecuentes y soporte de Tensolite";
  }, []);
  return (
    <>
      <Faqs />
    </>
  );
};

export default PreguntasFrecuentes;
